<script setup lang="ts">

import { computed, ref, onUnmounted } from "vue";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";
import dayjs from "dayjs";

type Props =
{
    variant?: string,
    label?: string
}

const { variant = 'tonal', label = 'Call Concierge' } = defineProps<Props>();

const button = ref();
defineExpose( { button } );

onUnmounted( () => clearInterval( handle ) );

const viewModel = await useViewModelInstance();
const now = ref( dayjs() );
const handle = setInterval( () => now.value = dayjs(), 10000  );

/**
 * True if we're outside the operating hours, or false if we're inside the operating hours
 */
const isOutsideOperatingHours = computed( () => 
{
    const day = now.value.day();
    if( day == 0 || day == 6 ) return true;

    const hour = now.value.hour();
    if( hour < 9 || hour >= 17 ) return true;

    return false;

});

</script>

<template>

    <div>
        <div v-if="isOutsideOperatingHours"
             class="pb-4 text-sm 3xl:text-lg opacity-50 text-center">
            Concierge is currently closed, please try again within business hours
        </div>

        <JupiterButton type="tel" 
                       class="flex !h-10 lg:!h-12 3xl:!h-14 mx-auto"
                       :to="viewModel.carePlan.carbucksRewards.conciergePhoneNumber"
                       :variant="variant"
                       :readonly="isOutsideOperatingHours"
                       :class="{ 'opacity-40': isOutsideOperatingHours }">
            <span ref="button"
                  class="flex items-center gap-1 3xl:gap-3">
                <Icon name="special:concierge-grayscale" class="text-2xl -mt-1 mr-1 opacity-70" />
                <span class="3xl:text-lg">
                    {{ label }}
                </span>
            </span>
        </JupiterButton>    
        <div class="text-xs 3xl:text-base opacity-50 text-center mt-1 lg:mt-1.5 3xl:mt-3">
            {{ viewModel.carePlan.carbucksRewards.conciergeHours }}
        </div>
    </div>
    
</template>